import {capitalize} from 'lodash';

export const camelCaseToSentenceCase = (value: string) => {
    const trimmedString = value.replace(/([A-Z])/g, ' $1');
    return capitalize(trimmedString);
};
